import {createSlice} from "@reduxjs/toolkit";

interface IInitialState {
  categories: null;
  savedCategories: [];
  isError: boolean;
  isSuccess: boolean;
  isSuccessUpdate: boolean;
  isLoading: boolean;
  fetchSavedCategoriesStatus: "idle" | "pending" | "resolved" | "rejected";
  message: string;
}

const initialState: IInitialState = {
  categories: null,
  savedCategories: [],
  isError: false,
  isSuccess: false,
  isSuccessUpdate: false,
  isLoading: false,
  fetchSavedCategoriesStatus: "idle",
  message: "",
};

export const categorySlice = createSlice({
  name: "category",
  initialState,
  reducers: {
    resetServiceState: (state) => {
      state.isError = false;
      state.isLoading = false;
      state.isSuccess = false;
      state.isSuccessUpdate = false;
      state.message = "";
      state.categories = null;
      state.savedCategories = [];
    },
    categoryLogoutReset: (state) => initialState,
  },
});

export const {resetServiceState, categoryLogoutReset} = categorySlice.actions;

export default categorySlice.reducer;
